/*
    Dispatching an async action inside a reducer.  It's anti-pattern to dispatch
    from inside a reducer and you'll get a `Cannot dispatch in a middle of dispatch`
    error.  You can however schedule a dispatch after current action.

    -- mdgcat
*/

const asyncDispatch = (store) => (next) => (action) => {
    let syncActivityFinished = false;
    let actionQueue = [];

    function flushQueue() {
        actionQueue.forEach((action) => store.dispatch(action)); // flush queue
        actionQueue = [];
    }

    function asyncDispatch(asyncAction) {
        actionQueue = actionQueue.concat([asyncAction]);

        if (syncActivityFinished) flushQueue();
    }

    const actionWithAsyncDispatch =  {...action, ...{ asyncDispatch }};

    next(actionWithAsyncDispatch);
    syncActivityFinished = true;

    flushQueue();
};

export default asyncDispatch;



// WEBPACK FOOTER //
// ./src/stores/asyncDispatch.js